/********************************************************************
 * Copyright (c) Certus Software, 2021.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import {Component, OnDestroy, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {NgcCookieConsentService} from 'ngx-cookieconsent';
import {AuthService} from '../../_services/auth.service';

@Component({
  selector: 'app-cookie-details',
  templateUrl: './cookie-details.component.html',
  styleUrls: ['./cookie-details.component.scss']
})
export class CookieDetailsComponent implements OnInit, OnDestroy {

  language: any;

  constructor(
    private ccService: NgcCookieConsentService,
    private translate: TranslateService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.language = this.translate.currentLang;
    this.ccService.destroy();
  }

  agreeButton() {
    this.authService.saveCookieData('dismiss');
  }

  ngOnDestroy() {
    if (!this.authService.isCookieApproved()) {
      location.reload();
    }
  }
}
